<template>
  <v-container id="dashboard-faturamento" class="px-6" >
      <v-row>
          <v-col class="pb-2" cols="10">
              <h1>Dashboard de faturamento</h1>
              <p>Visão gerencial do volume financeiro faturado do mês corrente, evolução mensal e comparação ao volume previsto.</p>
          </v-col>
          <v-col class="py-0 px-3" cols="12" sm="6" md="5">
            <legend>Prestador</legend>
            <v-select
                v-model="prestador_id"
                :items="prestadoresFilter"
                item-value="id"
                item-text="prest_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                placeholder="Selecione"
                flat
                solo
                dense
                outlined
                @change="prestadorFilter(prestador_id)"
            ></v-select>
          </v-col>
          <v-col class="pa-0" cols="12" sm="6" md="7"></v-col>
          <v-col cols="12" sm="12" md="4">
              <DashCard
                :cardAno="cardAno"
                :cardMes="cardMes"
                :filter="cardFilter"
              />
          </v-col>
          <v-col class="px-4 py-6" cols="12" sm="12" md="8">
              <v-card class="pa-4" outlined>
                  <h2>Faturado e Previsto por período</h2>
                  <p class="mb-0" style="font-size:10px">{{cardFilter? cardFilter.prest_nome: 'GERAL'}}</p>
                  <ChartBarLine
                    :list="listChart"
                  />
              </v-card>
          </v-col>
          <v-col class="pt-10 pb-1" cols="12">
              <h2>Visão analítica previsto x faturado</h2>
              <p style="font-size:12px">POR PRESTADOR E OPERADORA</p>
          </v-col>
          <v-col cols="12">
              <DashFilter
                :operadoras="listOperadora"
                :prestadores="prestadores"
                :updateFilter="(filter) => updateFilter(filter)"
                :dataReferencia = "dataReferencia"
              />
          </v-col>
          <v-col cols="12">
              <DashList
                :list="list"
                :getList="(page) => getList(filter, page)"
                :getFile="() => getFile(filterCsv)"
                :pagination="pagination"
                :totais="totaisDash"
              />
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DashCard from './dashboard_faturamento/DashCard'
import ChartBarLine from '../charts/ChartBarLine'
import DashFilter from './dashboard_faturamento/DashFilter'
import DashList from './dashboard_faturamento/DashList'
// import moment from 'moment'
export default {
    components: {
        DashCard,
        ChartBarLine,
        DashFilter,
        DashList
    },
    data() {
        return {
            dados: {},
            dataReferencia: null,
            totaisDash: {
                total_vl_prev_faturamento: 0,
                total_vl_faturamento: 0,
                total_porcem_faturado: 0
            },
            list: [],
            pagination: {
                limit: 10,
                offset: 1,
                current_page: 1,
            },
            cardFilter: null,
            prestadores: [],
            prestadoresFilter: [],
            prestador_id: null,
            cardAno: {},
            cardMes: {},
            listChart: {},
            filter: null,
            countDownTimer: null,
            display: '',
            filterCsv: null
        }
    },
    computed: {
    ...mapState({
        grupoEconomico: (state) => state.permissions.grupoEconomico,
        listOperadora: (state) => state.faturamento.listOperadora,
        }),
    },
    watch: {
        prestadores:{
            deep: true,
            handler(val){
                this.prestadoresFilter = Array.from(val)
                if (this.prestadoresFilter.length==1) {
                    this.prestador_id = this.prestadoresFilter[0].id
                    this.prestadorFilter(this.prestador_id)
                } else {
                    this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
                }
            }
        },
    }, 
    mounted() {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
        let userData = this.$store.state.userData.userData
        this.controlResponsavel = !userData.Permissao.faturamento.includes('gestor')
        let opts = {
            grupoEconomico: this.grupoEconomico,
            limitar: false,
            modulo_operadora: "faturamento"
            }
        this.getOperadoras(opts)
        this.refreshTimer()
        this.startTimer(300)
    },
    methods: {
        ...mapActions('permissions', [
        "getOperadoras",
        ]),
        startTimer(duration) {
            let timer = duration, minutes, seconds
            this.countDownTimer = setInterval(() => {
                minutes = parseInt((timer / 60).toString(), 10)
                seconds = (timer % 60).toString(), 10
                minutes = minutes < 10 ? "00:0" + minutes : "00:" + minutes
                seconds = seconds < 10 ? "0" + seconds : seconds
                this.display = minutes + ":" + seconds
                if (--timer < 0) {
                    timer = duration
                    this.refreshTimer()
                }
            }, 1000);
        },
        refreshTimer () {
            if (this.$route.path != '/faturamento/dashboarddefaturamento') {
                clearInterval(this.countDownTimer)
            } else {
                this.getList()
                this.getCards()
                this.getChart()
            }
        },
        prestadorFilter(filter) {
            let opts = {
                grupo_economico: this.grupoEconomico,
                prestador_id: filter
            }
            this.getCards(opts)
            this.getChart(opts)
            this.cardFilter = this.prestadoresFilter.find(el => el.id == this.prestador_id)
        },
        updateFilter(filter) {
            filter.dt_faturamento = filter.dt_faturamento!= null && filter.dt_faturamento.length==7? filter.dt_faturamento + '-01': filter.dt_faturamento
            this.getList(filter)
        },
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null
            const [day, month, year] = date.split("/")
            return `${year}-${month}-${day}`
        },
        selectToEditItem(item, showForm) {
            if (!item) return;
            this.editItem = { ...item };
            this.$nextTick(() => (this.showList = showForm ? false : this.showList));
        },
        getCards(filter) {
            this.$store.commit("showLoader",  { circle: true })
            let payload = filter? Object.assign(filter) : Object.assign({ grupo_economico: this.grupoEconomico })
            let obj = {
                query: [
                    {
                        Modulo: "Faturamento",
                        Acao: "getevolucaofaturamento",
                        Payload: payload,
                    },
                ],
            }
            this.$store.dispatch("request/doRequest", obj).then(response => {
                this.cardAno = response.faturamento_anual
                this.cardMes = response.faturado_mes_corrente
            })
        },
        getChart() {
            this.$store.commit("showLoader",  { circle: true })
            let payload = { grupo_economico: this.grupoEconomico, prestador_id:this.prestador_id }
            let obj = {
                query: [
                    {
                        Modulo: "Faturamento",
                        Acao: "getprevistofaturadoperiodo",
                        Payload: payload,
                    },
                ],
            }
            this.$store.dispatch("request/doRequest", obj).then(response => {
                this.listChart = response
            })
        },
        getFile(filterCsv){
            let modulo = "Faturamento"
            let acao = "getcsvprevistofaturadooperadora"
            let Payload = {...filterCsv, grupo_economico: this.grupoEconomico}
            this.$store.dispatch("documents/getDocumentPost", { Payload, acao, callback: ()=> setTimeout(()=>{}, 200), modulo }, {root:true})
        },
        getList(filter, page) {
            this.dataReferencia = null
            this.filterCsv = filter
            this.pagination.offset = page? page : 1
            let payload = filter? Object.assign(this.pagination, filter) : Object.assign(this.pagination,{ grupo_economico: this.grupoEconomico }) // this.grupoEconomico}
            let obj = {
                query: [
                    {
                        Modulo: "Faturamento",
                        Acao: "getprevistofaturadooperadora",
                        Payload: payload,
                    },
                ],
            }
            this.$store.dispatch("request/doRequest", obj).then((response) => {
                if (!response || response.isAxiosError || response.error) {
                this.$store.commit("hideLoader")
                return
                }
                let { dados, total_pages, current_page, dt_referencia, total_vl_prev_faturamento, total_vl_faturamento, total_porcem_faturado} = response
                this.list = dados
                this.pagination.total_pages = total_pages
                this.pagination.offset = current_page
                this.pagination.current_page = current_page
                this.dataReferencia = dt_referencia
                this.totaisDash.total_vl_prev_faturamento = total_vl_prev_faturamento
                this.totaisDash.total_vl_faturamento = total_vl_faturamento
                this.totaisDash.total_porcem_faturado = total_porcem_faturado
            })
        },
    },
}
</script>

<style scoped>
h2 {
  color: #430F4A;
  font-size: 16px;
  letter-spacing: 0.39px;
  line-height: 22px;
  font-weight: 500;
}
</style>